module.exports = __webpack_public_path__ + "img/MOBILE_Processo_Denuncia.a9d423c3.png";